import noticeModule from './Notice'
import judicialRulingModule from './JudicialRuling'
import lawyerRequestModule from './LawyerRequest'
import billRequest from './BillRequest/index.ts'
import communicationLines from './CommunicationLines/index.ts'
import prisonersModule from './Prisoners/index.ts'

export default {
  subModules: {
    notice: noticeModule,
    judicialRuling: judicialRulingModule,
    lawyerRequest: lawyerRequestModule,
    billRequest: billRequest,
    communicationLines: communicationLines,
    prisoners: prisonersModule,
  },
}
